import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useQueryParams from 'utils/hooks/useQueryParams'
import { ADMITAD_AUTH } from 'modules/Auth/types'

const AdmitadOauth = () => {
  const { query: { code } = {} } = useQueryParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: ADMITAD_AUTH, payload: { code } })
  }, [])

  return null
}

export default AdmitadOauth
